import { atom } from 'jotai';

export type NotificationSettings = {
  web?: { isActive: boolean };
  pushNotification?: { isActive: boolean };
  sms?: { isActive: boolean };
  email?: { isActive: boolean };
};

export type NotificationsSettings = {
  events: {
    orderSubmitted: NotificationSettings;
    orderFilled: NotificationSettings;
    orderPartFilled: NotificationSettings;
    orderUpdated: NotificationSettings;
    orderRevoked: NotificationSettings;
    orderRejected: NotificationSettings;
  };
};

export const defaultNotificationsSettings: NotificationsSettings = {
  events: {
    orderSubmitted: {
      web: { isActive: false },
      pushNotification: { isActive: false },
    },
    orderFilled: {
      web: { isActive: false },
      pushNotification: { isActive: false },
      sms: { isActive: false },
      email: { isActive: false },
    },
    orderPartFilled: {
      web: { isActive: false },
      pushNotification: { isActive: false },
      sms: { isActive: false },
      email: { isActive: false },
    },
    orderUpdated: {
      web: { isActive: false },
      pushNotification: { isActive: false },
    },
    orderRevoked: {
      web: { isActive: false },
      pushNotification: { isActive: false },
    },
    orderRejected: {
      web: { isActive: false },
      pushNotification: { isActive: false },
      sms: { isActive: false },
      email: { isActive: false },
    },
  },
};

export const notificationsSettingsAtom = atom<NotificationsSettings>(defaultNotificationsSettings);
